import * as React from "react";
import { Context } from "./_context";
export const NavigationPopBackIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.323 3.055a.25.25 0 0 1 .354 0l1.767 1.768a.25.25 0 0 1 0 .354L3.621 12l6.823 6.823a.25.25 0 0 1 0 .354l-1.767 1.767a.25.25 0 0 1-.354 0L.44 13.06a1.5 1.5 0 0 1 0-2.12l7.884-7.885Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationPopBackIcon.iconId = "me9qAB";
